import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-trash" }, null, -1 /* HOISTED */)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-angles-right" }, null, -1 /* HOISTED */)
const _hoisted_4 = [
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("button", {
      class: "btn",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.supprime && _ctx.supprime(...args)))
    }, [..._hoisted_2]),
    _createElementVNode("button", {
      class: "btn",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.edit && _ctx.edit(...args)))
    }, [..._hoisted_4])
  ]))
}